module.exports = __webpack_public_path__ + "img/74.fbe12e9c.jpg";